/**
 * Static configuration for getspeakhub-ui's own web OAuth2 client ("community_web_app").
 *
 * This is a second, independent OAuth2 client from the mobile app's — see D9 of
 * .claude/contracts/referral-leaderboard-program.md. It is registered server-side
 * in api-gw's configuration/application/oauth2.json and must stay in sync with it
 * (client_id here must match the `client_id` field of that entry).
 *
 * client_id is not a secret (it is a PKCE public identifier sent in the browser);
 * the matching client_secret never leaves api-gw / the deployment's Nginx layer —
 * see infrastructure/auth/oauth2Client.ts for how the token exchange avoids
 * shipping it to the browser.
 */
export const OAUTH2_CLIENT_ID = 'community-web-app-2940bdde-b638-44be-9177-297ce4104e8e';

// Relative to API_GATEWAY_URL (proxied to api-gw's /gw/* by Nginx in prod and by
// src/setupProxy.js in dev) — used for the AJAX token exchange/refresh call.
export const OAUTH2_TOKEN_PATH = 'oauth2/token';

// Relative to API_GATEWAY_ABS_URL (api-gw's own absolute origin) — used for the
// full-page browser redirect that starts the Authorization Code + PKCE flow.
export const OAUTH2_AUTHORIZE_PATH = 'oauth2/authorize';

export const OAUTH2_SCOPE = 'ROLE_USER ROLE_COMMUNITY_WEB';

export const AUTH_CALLBACK_PATH = '/auth/callback';
